import gryffindorLogo from "../images/houses/gryffindor.png";
import hufflepuffLogo from "../images/houses/hufflepuff.png";
import ravenclawLogo from "../images/houses/ravenclaw.png";
import slytherinLogo from "../images/houses/slytherin.png";

export const HOUSES = [
  {
    id: "gryffindor",
    name: "Gryffindor",
    title: "Where courage defines every step…",
    motto: "The Brave",
    crestLine: "Courage & Valor",
    logo: gryffindorLogo,
  },
  {
    id: "hufflepuff",
    name: "Hufflepuff",
    title: "Where loyalty stands above all…",
    motto: "The Loyal",
    crestLine: "Dedication & Patience",
    logo: hufflepuffLogo,
  },
  {
    id: "ravenclaw",
    name: "Ravenclaw",
    title: "Where wisdom shapes every spell…",
    motto: "The Wise",
    crestLine: "Wit & Learning",
    logo: ravenclawLogo,
  },
  {
    id: "slytherin",
    name: "Slytherin",
    title: "Where ambition leads to greatness…",
    motto: " The Ambitious",
    crestLine: "Ambition & Cunning",
    logo: slytherinLogo,
  },
];

export function pickRandomHouse() {
  return HOUSES[Math.floor(Math.random() * HOUSES.length)];
}

export function getHouseById(id) {
  return HOUSES.find((h) => h.id === id) ?? null;
}
